// services/patrol_state.js
export default class PatrolState {
  constructor() {
    this.currentCheckpointIndex = -1
    this.checkpoints = null
    this.permissionsGranted = false
  }

  initializeCheckpoints(checkpoints) {
    this.checkpoints = checkpoints
    this.currentCheckpointIndex = -1  // Start before the first checkpoint
  }

  async nextCheckpoint() {
    if (!this.checkpoints?.length) return null
    this.currentCheckpointIndex++
    return this.currentCheckpointIndex < this.checkpoints.length ?
      this.checkpoints[this.currentCheckpointIndex] : null
  }

  get currentCheckpoint() {
    return this.checkpoints?.[this.currentCheckpointIndex]
  }

  get isFirstCheckpoint() {
    return this.currentCheckpointIndex === -1
  }

  get hasCurrentCheckpoint() {
    return this.currentCheckpointIndex >= 0 && this.currentCheckpointIndex < this.checkpoints.length && this.checkpoints
  }

  setPermissionsGranted(granted) {
    this.permissionsGranted = granted
  }

  reset() {
    this.currentCheckpointIndex = -1
    this.checkpoints = null
    this.permissionsGranted = false
  }
}
